/**
 * Famílias usadas no documento: cada nome corresponde a @font-face em texts.scss
 * com src em public/fonts (vários arquivos .ttf por família viram uma opção).
 */
export const DOCUMENT_FONT_FAMILY_OPTIONS: readonly string[] = [
    'Amatic SC',
    'Archivo',
    'Arial',
    'Caveat',
    'CenturyGothic',
    'Comfortaa',
    'EB Garamond',
    'Lexend',
    'Lobster',
    'Lora',
    'Merriweather',
    'Montserrat',
    'Nunito',
    'Oswald',
    'Pacifico',
    'Playfair Display',
    'Roboto',
    'Roboto Mono',
    'Roboto Serif',
    'Spectral',
    'Times New Roman',
];
